import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const TRANSLATIONS = {
  fr: {
    title: 'GRILLE TARIFAIRE - PARTY LED',
    subtitle: 'Kits LED pour événements de 50 à 1000 personnes',
    kit: 'Kit',
    guests: 'Personnes',
    price: 'Prix (EUR)',
    pricePerPerson: 'Prix/Pers.',
    included: 'Inclus dans chaque kit',
    features: [
      'Bracelets LED ultra-premium (quantité selon le kit)',
      '1 contrôleur au choix : mini / application mobile / professionnel ordinateur',
      'Marquage en 1 couleur inclus sur le bracelet',
      'Insertion du lien NFC vers l\'url de votre choix',
    ],
    option: 'Option : Animateur ou DJ + 1 technicien éclairage ou technicien d\'éclairage seul',
    contact: 'Contact',
    europe: 'Europe : Nouvelle Vision — 8 Rue Saint Savournin, 13001 Marseille, France',
    uae: 'UAE : World Promotional Products — Opal Tower, Burj Khalifa Blvd, Office 307/22, Business Bay, Dubai',
    website: 'www.party-led.com',
    footer: 'Devis personnalisé sur demande — Livraison France & Emirats',
  },
  en: {
    title: 'PRICE GRID - PARTY LED',
    subtitle: 'LED kits for events from 50 to 1000 guests',
    kit: 'Kit',
    guests: 'Guests',
    price: 'Price (EUR)',
    pricePerPerson: 'Price/Guest',
    included: 'Included in every kit',
    features: [
      'Ultra-premium LED wristbands (quantity per kit)',
      '1 controller of your choice: mini / mobile app / professional computer',
      '1-color branding included on the wristband',
      'NFC link insertion to the URL of your choice',
    ],
    option: 'Option: Entertainer or DJ + 1 lighting technician or lighting technician alone',
    contact: 'Contact',
    europe: 'Europe: Nouvelle Vision — 8 Rue Saint Savournin, 13001 Marseille, France',
    uae: 'UAE: World Promotional Products — Opal Tower, Burj Khalifa Blvd, Office 307/22, Business Bay, Dubai',
    website: 'www.party-led.com',
    footer: 'Custom quote on request — Delivery France & UAE',
  },
  ar: {
    title: 'جدول الأسعار - PARTY LED',
    subtitle: 'أطقم LED للفعاليات من 50 إلى 1000 ضيف',
    kit: 'طقم',
    guests: 'أشخاص',
    price: 'السعر (EUR)',
    pricePerPerson: 'السعر/شخص',
    included: 'مضمن في كل طقم',
    features: [
      'أساور LED فائقة الجودة (الكمية حسب الطقم)',
      'وحدة تحكم واحدة حسب اختيارك: صغيرة / تطبيق الهاتف / احترافية',
      'طباعة بلون واحد مضمنة على السوار',
      'إدراج رابط NFC نحو الرابط الذي تختاره',
    ],
    option: 'خيار: منشط أو DJ + 1 فني إضاءة أو فني إضاءة فقط',
    contact: 'اتصل بنا',
    europe: 'أوروبا: Nouvelle Vision — 8 Rue Saint Savournin, 13001 Marseille, France',
    uae: 'الإمارات: World Promotional Products — Opal Tower, Burj Khalifa Blvd, Office 307/22, Business Bay, Dubai',
    website: 'www.party-led.com',
    footer: 'عرض سعر مخصص عند الطلب — التوصيل فرنسا والإمارات',
  },
  it: {
    title: 'GRIGLIA TARIFFARIA - PARTY LED',
    subtitle: 'Kit LED per eventi da 50 a 1000 persone',
    kit: 'Kit',
    guests: 'Persone',
    price: 'Prezzo (EUR)',
    pricePerPerson: 'Prezzo/Pers.',
    included: 'Incluso in ogni kit',
    features: [
      'Braccialetti LED ultra-premium (quantità secondo il kit)',
      '1 controller a scelta: mini / app mobile / professionale per computer',
      'Personalizzazione a 1 colore inclusa sul braccialetto',
      'Inserimento link NFC verso l\'URL di tua scelta',
    ],
    option: 'Opzione: Animatore o DJ + 1 tecnico luci o tecnico luci da solo',
    contact: 'Contatti',
    europe: 'Europa: Nouvelle Vision — 8 Rue Saint Savournin, 13001 Marseille, France',
    uae: 'EAU: World Promotional Products — Opal Tower, Burj Khalifa Blvd, Office 307/22, Business Bay, Dubai',
    website: 'www.party-led.com',
    footer: 'Preventivo personalizzato su richiesta — Consegna Francia & Emirati',
  },
};

export const generatePriceGridPDF = (products, lang = 'fr') => {
  const tr = TRANSLATIONS[lang] || TRANSLATIONS.fr;
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  // Purple header background
  doc.setFillColor(88, 28, 135);
  doc.rect(0, 0, 210, 45, 'F');

  // Title
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.text(tr.title, 105, 20, { align: 'center' });

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.text(tr.subtitle, 105, 32, { align: 'center' });

  // Sort products by price
  const sorted = [...products].sort((a, b) => a.price - b.price);

  // Table data
  const tableData = sorted.map((p) => {
    const qty = p.name.match(/(\d+)/)?.[1] || '';
    const pricePerPerson = (p.price / parseInt(qty || '1', 10)).toFixed(2);
    return [
      `${qty} ${tr.guests}`,
      `${p.price.toLocaleString('fr-FR')} €`,
      `${pricePerPerson} €`,
    ];
  });

  // Price table
  autoTable(doc, {
    startY: 52,
    head: [[tr.kit, tr.price, tr.pricePerPerson]],
    body: tableData,
    theme: 'grid',
    headStyles: {
      fillColor: [88, 28, 135],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      fontSize: 11,
      halign: 'center',
    },
    bodyStyles: {
      fontSize: 10,
      halign: 'center',
      textColor: [30, 30, 30],
    },
    alternateRowStyles: {
      fillColor: [245, 243, 255],
    },
    columnStyles: {
      0: { fontStyle: 'bold' },
      1: { fontStyle: 'bold' },
    },
    margin: { left: 20, right: 20 },
  });

  // Features section
  const afterTable = doc.lastAutoTable.finalY + 10;

  doc.setFillColor(245, 243, 255);
  doc.roundedRect(20, afterTable, 170, 48, 3, 3, 'F');

  doc.setTextColor(88, 28, 135);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text(tr.included, 30, afterTable + 9);

  doc.setTextColor(60, 60, 60);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  tr.features.forEach((f, i) => {
    doc.text(`  •  ${f}`, 30, afterTable + 18 + i * 6);
  });

  // Option line
  doc.setFontSize(9);
  doc.setTextColor(88, 28, 135);
  doc.setFont('helvetica', 'bold');
  doc.text(tr.option, 30, afterTable + 44);

  // Contact section
  const contactY = afterTable + 58;
  doc.setDrawColor(88, 28, 135);
  doc.setLineWidth(0.5);
  doc.line(20, contactY, 190, contactY);

  doc.setTextColor(88, 28, 135);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text(tr.contact, 105, contactY + 8, { align: 'center' });

  doc.setTextColor(60, 60, 60);
  doc.setFontSize(8.5);
  doc.setFont('helvetica', 'normal');
  doc.text(tr.europe, 105, contactY + 16, { align: 'center' });
  doc.text(tr.uae, 105, contactY + 22, { align: 'center' });
  doc.text(tr.website, 105, contactY + 28, { align: 'center' });

  // Footer
  doc.setFillColor(88, 28, 135);
  doc.rect(0, 282, 210, 15, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9);
  doc.text(tr.footer, 105, 290, { align: 'center' });

  doc.save(`party-led-tarifs-${lang}.pdf`);
};
